import React, { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import AuthGate from '../../components/AuthGate/AuthGate';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import { useThemeColor } from '../../hooks/useThemeColor';
import authService from '../../services/auth.service';

const ForgotPassword: React.FC = () => {
  useThemeColor('#6B21A8');
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const validate = (): boolean => {
    if (!email) {
      setEmailError('L\'email est obligatoire');
      return false;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setEmailError('Email invalide');
      return false;
    }
    setEmailError('');
    return true;
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!validate()) return;

    setIsLoading(true);
    setError('');
    try {
      await authService.requestPasswordReset(email.trim());
      setSent(true);
    } catch {
      setError('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthGate
      panel={{
        eyebrow: 'Compte',
        title: <>Retrouver <em>l’accès.</em></>,
        lead: 'Un lien, une heure.',
      }}
    >
      <p className="auth-kicker">Mot de passe</p>
      <h1 className="auth-h">{sent ? 'E-mail envoyé' : 'Mot de passe oublié'}</h1>
      <p className="auth-sub">
        {sent ? 'Vérifiez votre boîte.' : 'Un lien de réinitialisation.'}
      </p>

      {sent ? (
        <>
          <div className="auth-alert auth-alert--ok">
            Si un compte correspond, un lien valable 1 h a été envoyé.
          </div>
          <div className="auth-foot">
            <p><Link to="/login">Retour à la connexion</Link></p>
          </div>
        </>
      ) : (
        <>
          {error && <div className="auth-alert auth-alert--error">{error}</div>}
          <form className="auth-form" onSubmit={handleSubmit}>
            <Input
              label="Email"
              type="email"
              name="email"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setEmailError(''); setError(''); }}
              error={emailError}
              placeholder="vous@exemple.com"
              required
              fullWidth
              autoComplete="email"
            />
            <Button type="submit" variant="primary" size="large" fullWidth loading={isLoading}>
              Envoyer le lien
            </Button>
          </form>
          <div className="auth-foot">
            <p><Link to="/login">Retour à la connexion</Link></p>
          </div>
        </>
      )}
    </AuthGate>
  );
};

export default ForgotPassword;
